angular.module('Directives')
    .directive('ngInputSelect',
    function($timeout){
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/ngInputSelect.html',
            replace: true,
            scope: {
                ngModel: '=',
                ngDisable: '=',
                ngOnSelect: '&',
                ngClass: '@',
                items: '=',
                placeholder: '@',
                id: '@'
            },
            controller: inputSelectCtr
        }

        function inputSelectCtr($scope, $element){
            $scope.select = function(item){
                $scope.ngModel = _.has(item, 'value') ? item.value : item;
                $timeout(function(){
                    $scope.ngOnSelect();
                });
            };
            $timeout(function(){
                $scope.elementWidth = $element.width();
            });
        }
    });


// WEBPACK FOOTER //
// ./js/directives/ngInputSelect.js